var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 59.53,
    y1: 147,
    x2: 144.84,
    y2: 47.94,
    gradientTransform: "translate(100 -41.42) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M107.11,192.89v-85.78h85.78c3.93,0,7.11-3.18,7.11-7.11,0-3.93-3.18-7.11-7.11-7.11h-85.78s0-85.78,0-85.78C107.11,3.18,103.93,0,100,0s-7.11,3.18-7.11,7.11v85.78H7.11c-1.89,0-3.69.75-5.03,2.08-2.78,2.78-2.77,7.28,0,10.05,1.33,1.34,3.14,2.08,5.03,2.08h85.78v85.78c0,1.89.75,3.69,2.08,5.03,1.33,1.33,3.14,2.08,5.03,2.08,3.93,0,7.11-3.18,7.11-7.11Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }));
};
export default SvgPlus;